import { getXmlFile } from '../common/xmlretriever';
import { parseXMLtoJS }  from '../common/parseXMLtoJS';



class GameMenuDM {
    constructor() {
        this.basePath = '';
        this.configxml = '';
        this.games = [];
        this.isLoaded = false;
    }

}





var iteamGameModelInstance = (function () {
    var successGameMenuModelCallBack = null;
    var failureGameMenuModelCallBack = null;

    function httpXmlTypeGameMenuResponseSuccess(response, sectionItem) {

        let gameMenuJS = parseXMLtoJS(response.data);

        sectionItem.isLoaded = true;
        sectionItem.gameMenuDM = new GameMenuDM();

        let xmlFilePath = `${sectionItem.basePath}/${sectionItem.configxml}`; // used to construct new base path
        let pathParts =  xmlFilePath.split('/');
        pathParts.pop(); // remove xml file, and get directory parts only
        let newBasePath = pathParts.join('/');
        sectionItem.gameMenuDM.basePath = sectionItem.basePath;
        sectionItem.gameMenuDM.configxml = sectionItem.configxml;


        gameMenuJS.gamesmenu.game.forEach(item => {
            sectionItem.gameMenuDM.games.push({
                    configxml: item.config._text, 
                    basePath: newBasePath,
                    icon: item.icon._text, 
                    image: null, 
                    name: item.name._text});
        });

        if (successGameMenuModelCallBack !== null) {
            successGameMenuModelCallBack(sectionItem.gameMenuDM);
            successGameMenuModelCallBack = null;
            successGameMenuModelCallBack = null;
        }
    }

    function httpXmlTypeGameMenuResponseFailure(error) {
        console.log(error);
        if (failureGameMenuModelCallBack !== null) {
            failureGameMenuModelCallBack(error);
            failureGameMenuModelCallBack = null;
            failureGameMenuModelCallBack = null;
        }
    }

    function _loadGameMenu(sectionItem) {


        let xmlFilePath = `${sectionItem.basePath}/${sectionItem.configxml}`;


        
        getXmlFile(`${xmlFilePath}`, 
                        (response) => httpXmlTypeGameMenuResponseSuccess(response, sectionItem), 
                        httpXmlTypeGameMenuResponseFailure);


    }

    return { // public interface
        loadGameMenu: function (sectionItem, successCallBack, errorCallBack) {
            successGameMenuModelCallBack = successCallBack;
            failureGameMenuModelCallBack = errorCallBack;
            _loadGameMenu(sectionItem);
        },
    };

})();


export {
    GameMenuDM,
    iteamGameModelInstance
};